module.exports = __webpack_public_path__ + "img/Download (3).5cfdae40.svg";